import React, { FC, useState } from 'react';

import { Container } from '../../components/container/container';
import {
  EmptyFilter,
  ServicesBase,
  ServicesTitleBase,
  SideFilterBase,
  StyledGridServiceCard,
  TopServicesBase,
  TopServicesWrap,
} from './style';
import {
  Button,
  CardServices,
  EnumPagination,
  Title,
  Row,
  Col,
  DepartmentSections,
  useMediaQuery
} from '@plataformaxvia/design-system';
import { useTheme } from '@mui/material/styles';
import { Grid } from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import WarningIcon from '@mui/icons-material/Warning';
import { WarningModal } from '../../components/warning-modal/WarningModal';
import { ContainerModalAction } from '../../components/warning-modal/style';
import { HeaderTitle } from '../../components/header-title/header-title';
import { SectionLocation } from './section-location/section-location';

interface CardServicesPros {
  title: string;
  category: string;
  onInfoClick: () => void;
  onRequestClick: () => void;
  isDigital: boolean;
  isOnline: boolean;
  totalServices: number;
}

export interface ServicesByDepartmentSectionProps {
  services?: CardServicesPros[];
  setCurrentPage: (page: number) => void;
  currentPage: number;
  totalPages: number;
  isRedirectWarningModalOpen?: boolean;
  toggleRedirectWarningModal: () => void;
  handleRedirectWarningModalConfirm: () => void;
  section?: DepartmentSections;
}

export const ServicesByDepartmentSection: FC<ServicesByDepartmentSectionProps> =
  ({
    services,
    setCurrentPage,
    currentPage,
    totalPages,
    section,
    isRedirectWarningModalOpen = false,
    toggleRedirectWarningModal,
    handleRedirectWarningModalConfirm,
  }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down(780));

    return (
      <>
        <HeaderTitle title={section?.name || 'Seção'} />
        <TopServicesWrap>
          <WarningModal
            headerTitle="Atenção!"
            icon={<WarningIcon />}
            headerBgColor="var(--color-background-card-warning-header)"
            onCloseModal={toggleRedirectWarningModal}
            modalOpen={isRedirectWarningModalOpen}
          >
            <p>
              Você está sendo redirecionado para um link externo. Tem certeza
              que deseja continuar?
            </p>

            <ContainerModalAction>
              <Button
                onClick={handleRedirectWarningModalConfirm}
                label="Confirmar redirecionamento"
              />
            </ContainerModalAction>
          </WarningModal>
          <Container>
            <TopServicesBase>
              <SideFilterBase
                className={
                  'filter-content xvia-catalog-search-input__input-list'
                }
                style={{ display: 'block', flexShrink: 0 }}
              >
               {section && <SectionLocation section={section} mapUrl={section.mapUrl} />}
              </SideFilterBase>
              <ServicesBase>
                <ServicesTitleBase>
                  <Row justifyContent="space-between" style={{ width: '100%' }}>
                    <Col base={6}>
                      <Title title={'Serviços disponíveis'} as="h2" />
                    </Col>
                  </Row>
                </ServicesTitleBase>
                <StyledGridServiceCard container spacing={3}>
                  {services &&
                    services.length > 0 &&
                    services?.map((service, index) => (
                      <Grid
                        item
                        xs={12}
                        sm={isSmallScreen ? 12 : 6}
                        key={index}
                      >
                        <CardServices {...service} />
                      </Grid>
                    ))}
                  {services && services.length === 0 && (
                    <EmptyFilter>
                      <FilterAltOffIcon />
                      Nenhum resultado encontrado para os filtros selecionados.
                      Tente ajustar os critérios de busca.
                    </EmptyFilter>
                  )}
                </StyledGridServiceCard>
                {totalPages > 1 && (
                  <Grid
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                    }}
                  >
                    <EnumPagination
                      currentPage={currentPage}
                      onPageChange={setCurrentPage}
                      setCurrentPage={setCurrentPage}
                      totalPages={totalPages}
                    />
                  </Grid>
                )}
              </ServicesBase>
            </TopServicesBase>
          </Container>
        </TopServicesWrap>
      </>
    );
  };
